
export function attachEventListeners(ctx) {
    const {
        filtersContainer,
        dateFromInput,
        dateToInput,
        clearButton,
        searchInput
    } = ctx.filterElements || {};

    if (dateFromInput) {
        dateFromInput.addEventListener('change', () => ctx.handleDateFromChange());
    }

    if (dateToInput) {
        dateToInput.addEventListener('change', () => ctx.handleDateToChange());
    }

    if (clearButton) {
        clearButton.addEventListener('click', () => ctx.clearAllFilters());
    }

    if (searchInput) {
        searchInput.addEventListener('input', () => ctx.handleSearchInput());
    }

    // Public only filter checkbox
    const publicOnlyCheckbox = document.getElementById('public-only-filter');
    if (publicOnlyCheckbox) {
        const publicOnlyRow = publicOnlyCheckbox.closest('.public-only-filter-row');
        
        publicOnlyCheckbox.addEventListener('change', () => {
            // Add subtle color wave effect
            if (publicOnlyRow) {
                publicOnlyRow.classList.add('ripple-effect');
                setTimeout(() => {
                    publicOnlyRow.classList.remove('ripple-effect');
                }, 1800);
            }
            
            // Apply filters immediately (without URL update)
            if (ctx.applyFilters) {
                ctx.applyFilters(false); // false = don't update URL immediately
            }
            
            // Update URL with pu parameter immediately (with small delay to ensure checkbox state is updated)
            setTimeout(() => {
                if (window.filterController && typeof window.filterController.updateUrlWithFilters === 'function') {
                    window.filterController.updateUrlWithFilters(true); // true = immediate update
                }
            }, 50);
            
            // Trigger debounced search to update URL when search executes
            if (ctx.triggerDebouncedSearch) {
                ctx.triggerDebouncedSearch();
            }
        });
    }
}


